<template>
  <div class="navigation" :style="'width:' + (show ? '220' : '50') + 'px;'" v-if="!hiddenLeft">
    <!-- 一级菜单 -->
    <ul class="stair">
      <li v-for="(item, index) in list" v-bind:key="index" :class="item.checked ? 'on' : ''" @click="cutStair(index,item)">
        <div class="nav-badge">
          <div class="icon-box">
            <i class="navigation-icon" :class="item.meta.icon"></i>
            <span>{{item.powername}}</span>
          </div>
        </div>
      </li>
    </ul>
    <!-- 二级及以下菜单 -->
    <div class="second" v-show="showOn">
      <div class="title">{{ list[second].meta.title }}</div>
      <el-scrollbar wrap-class="scrollbar-wrapper">
        <!-- :collapse="isCollapse" :default-openeds="list[second].powername == '报表'?['/basicReport']:[$route.path]"-->
        <el-menu
          background-color="#fff"
          text-color="#353535"
          :unique-opened="true"
          :default-active="activePath"
          active-text-color="#19bd92"
          :collapse-transition="false"
          :default-openeds="list[second].powername == '报表'?['/basicReport']:[activePath]"
          mode="vertical"
          ref="menuref"
        >
         <!-- :dataindex="second" -->
          <sidebar-item v-for="(route,index) in list[second].children" :key="index" :item="route" :base-path="route.path" />
        </el-menu>
     </el-scrollbar>
    </div>
  </div>
</template>
<script>
import router from "@/router";
import xz from "@/common";
import SidebarItem from './SidebarItem';
export default {
  components: {SidebarItem},
  props: {
    show: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      showOn: true,
      hiddenLeft:this.$store.state.hiddenLeft,
      visible: false,
      list: [],
      leftNum: "",
      second: 0,
      current: 0,
      activePath:'',// 选中菜单的index
      isAnalysis: '',
      proRemindNum:'',
      pathName:'',
      defaultpath:'',
      openPath:[]
    }
  },
  watch: {
    $route: "setPathOn",
    show() {
      this.showOn = this.show
    },
    '$store.state.menu.leftNum': function () {
      let that = this
      this.$nextTick(() => {
        that.leftNum = this.$store.state.menu.leftNum;
        that.getRemindNum();
      })
      // console.log('daa',this.leftNum)
    },
    '$store.state.hiddenLeft':function(){
      this.hiddenLeft = this.$store.state.hiddenLeft;
      // console.log('ttt',this.leftNum)
    },
    '$store.state.menu.proRemindNum': function () {
      this.proRemindNum = this.$store.state.menu.proRemindNum
      this.getRemindNum()
    }
  },
  computed: {
    // activePath(){
    //   return this.$route.path.replace('/','')
    // }
    // leftNum(){
    //   return this.$store.getters.menu.getterCount
    // }
  },
  mounted() {
    this.pathName = location.pathname
    if ((this.pathName.indexOf('projectList')>-1||this.pathName.indexOf('exportList')>-1||this.pathName.indexOf('contractReminder')>-1)||this.pathName.indexOf('customerList')>-1||this.pathName.indexOf('customList')>-1||this.pathName.indexOf('cusExportList')>-1||this.pathName == '/') {
      this.$store.commit("SET_Pronum")
    }
    this.setPathOn();
    // console.log('gg', this.pathName)
  },
  created() {
    let that = this;
    that.defaultpath = location.pathname
    this.isAnalysis = localStorage.isAnalysis
    // this.activePath = location.pathname
    this.list = this.$store.state.menu.router
    this.$router.addRoutes(this.$store.state.menu.router)
    // 根据路由判断父级菜单选中
    if(!this.isNull(this.list)){
      let paths;
      if(location.pathname == '/'){// 默认路由处理
        paths = '/staging'
        this.second = 0
        this.list[this.second].checked = true
        this.list[this.second].meta.checked = true
        that.activePath = paths
      }else{
        // 初始化完成
        this.$router.onReady(() => {
          let route = that.$route;//页面路由信息
          let routequery = JSON.stringify(route.query)//页面传的参数
          let routepath = route.path;
          let pathname = location.pathname;
          // let { path, meta } = route;
          let metainfo = route.meta.activeMenu;
          // 判断详情页或内页选中菜单
          paths = that.actPathHandle(routequery,routepath,metainfo);
          // console.log('wwww', paths,route)
          let checkedRes = this.getTreeName(this.list, paths);
          // console.log('ass',checkedRes)
          if(!this.isNull(checkedRes)){
            // console.log('111111111')
            if(this.isNull(checkedRes.parentindex)){
              // console.log('22222')
              if(this.isNull(checkedRes.childindex)){
                // console.log('3333333333')
                this.second = 0
              }else{
                // console.log('4444444')
                this.second = checkedRes.childindex
              }
            }else{
              // console.log('555555555')
              this.second = checkedRes.parentindex
            }
          }else{
            // console.log('666666')
            this.second = 0
          }
          this.list[this.second].checked = true
          this.list[this.second].meta.checked = true
          this.list.forEach((item, index) => {
            if (index != this.second) {//其他一级菜单不选中
              item.checked = false;
              item.meta.checked = false
            }
          })
          // 根据路由判断子级菜单选中
          // that.activePath = that.actPathHandle(routequery,routepath,metainfo);
          that.activeMenu();
        })
      }
    }else {
      this.second = 0
    }
  },
  methods: {
    activeMenu() {
      let that = this
      // 初始化完成时的回调方法 onReady
      this.$router.onReady(() => {
        let route = that.$route
        let { path, meta } = route
        let routequery = JSON.stringify(route.query)//页面传的参数
        let routepath = route.path
        let metapath = meta.activeMenu
        let actMetaPath = '';
        // 资源详情和分配详情列表
        actMetaPath = that.actPathHandle(routequery,routepath,metapath)
        if (!that.isNull(actMetaPath)) {
          that.activePath = actMetaPath
        }else{
          that.activePath = routepath
        }
        // console.log('gggg',that.activePath)
      })
    },
    // 判断详情页路由或新增/编辑页面时选中的菜单路由
    actPathHandle(routequery,routepath,metapath){
      let actMetaPath;
      let that = this;
      if(!that.isNull(metapath)){
        actMetaPath = metapath
      }else{
        if(((routequery.indexOf('member')>-1)&&(routepath.indexOf('/teamReminder')>-1))||(routepath.indexOf('teamMemberDetail')>-1)||(routepath.indexOf('updateTeamMember')>-1)){// 灵活用工提醒特殊处理
          actMetaPath = '/teamMembers';
        }else if(((routequery.indexOf('team')>-1)&&(routepath.indexOf('/teamReminder')>-1))||(routepath.indexOf('supplyDetail')>-1)||(routepath.indexOf('updateSupply')>-1)||(routepath.indexOf('recertification')>-1)){
          actMetaPath = '/supplierManage';
        }else if(routequery.indexOf('report')>-1&&(routepath.indexOf('/effExportList')>-1)){
          actMetaPath = '/report';
        }else if(routequery.indexOf('channelClassification')>-1&&(routepath.indexOf('/effExportList')>-1)){
          actMetaPath = '/channelClassification';
        }else if((routequery.indexOf('个人资源')>-1)&&(routepath.indexOf('/dtlResource')>-1||routepath.indexOf('/divideList')>-1)){
          actMetaPath = '/personalResources';
        }else if(routequery.indexOf('公海资源')>-1&&(routepath.indexOf('/dtlResource')>-1||routepath.indexOf('/divideList')>-1)){
          actMetaPath = '/publicResources';
        }else{
          actMetaPath = routepath
        }
      }
      return actMetaPath
    },
    isCollapse() {
      // return !this.sidebar.opened
      return false
    },
    //获取提醒数量
    getRemindNum() {
      let that = this
      let firstNum;
      let secondNum;
      let remindNum1,remindNum2;
      if (this.list.length > 0) {
        // console.log(33233,this.list)
        this.list.forEach((element, index) => {
          if(element.powercode == '1c895257-a000-d000-b000-adb6df000006') {//通知
            firstNum = index
          }
          if(element.powercode == '1c895257-a000-d000-b000-adb6df000001') {//客户
            remindNum1 = index
          }
          if(element.children&&element.children.length>0){
            let eleSecond = element.children
            // console.log('menu', that.$store.state.menu)
            let num = that.$store.state.menu.proRemindNum
            eleSecond.forEach((item, i) => {//二级菜单
              let eleThird = item.children
              if(item.powercode == '1c895257-a000-d000-b001-adb6df000006') {//待办事项
                secondNum = i
                that.calNum(firstNum,secondNum)
              }
              if(item.powercode == '1c895257-a000-d000-b002-adb6df000001') {//项目
                remindNum2 = i
              }
              if(eleThird&&eleThird.length>0){
                eleThird.forEach((ele, j) => {//三级菜单
                  if(ele.powercode == '1c895257-a000-d004-b002-adb6df000001') {//商务合同提醒
                    // console.log('num',num)
                    that.$set(that.list[remindNum1].children[remindNum2].children[j], "badge", num)
                  }
                })
              }
            })
          }
        })
      }
    },
    // 设置待办提醒数量
    calNum(num,secondNum) {
      // console.log(111,this.leftNum,num,secondNum)
      let that = this
      if (this.leftNum) {
        var retircont = parseInt(this.leftNum.msg.oldmancont) + parseInt(this.leftNum.msg.oldwemencont);
        var yongcont = parseInt(this.leftNum.msg.yong16cont) + parseInt(this.leftNum.msg.yong18cont);
        var countnum = parseInt(this.leftNum.msg.cardcont) + parseInt(this.leftNum.msg.contcont) + parseInt(this.leftNum.msg.hurtcount) + parseInt(this.leftNum.msg.doublecount) + parseInt(this.leftNum.msg.oldcont) + parseInt(this.leftNum.msg.testcont) + parseInt(this.leftNum.msg.yong16cont) + parseInt(this.leftNum.msg.yong18cont) + parseInt(this.leftNum.msg.oldmancont) + parseInt(this.leftNum.msg.oldwemencont);
        // this.list[2].badge = countnum;
        let a = num;
        let eleData = this.list[a].children[secondNum].children;
        // console.log(111,eleData)
        that.$set(this.list[a], "badge", countnum);
        eleData.forEach((element, index) => {
          if (element.powercode == '1c895257-a000-d001-b001-adb6df000006') {//身份证到期提醒
            let i1 = index;
            that.list[a].children[secondNum].children[i1].badge = parseInt(that.leftNum.msg.cardcont);
          }
          if (element.powercode == '1c895257-a000-d002-b001-adb6df000006') {//试用期到期提醒
            let i2 = index;
            that.list[a].children[secondNum].children[i2].badge = parseInt(that.leftNum.msg.testcont);
          }
          if (element.powercode == '1c895257-a000-d003-b001-adb6df000006') {//合同到期提醒
            let i3 = index;
            that.list[a].children[secondNum].children[i3].badge = parseInt(that.leftNum.msg.contcont);
          }
          if (element.powercode == '1c895257-a000-d004-b001-adb6df000006') {//未成年提醒
            let i4 = index;
            that.list[a].children[secondNum].children[i4].badge = parseInt(yongcont);
          }
          if (element.powercode == '1c895257-a000-d005-b001-adb6df000006') {//退休提醒
            let i5 = index;
            that.list[a].children[secondNum].children[i5].badge = parseInt(retircont);
          }
          if (element.powercode == '1c895257-a000-d006-b001-adb6df000006') {//重复入职提醒
            let i6 = index;
            that.list[a].children[secondNum].children[i6].badge = parseInt(that.leftNum.msg.doublecount);
          }
          if (element.powercode == '1c895257-a000-d007-b001-adb6df000006') {//65周岁提醒
            let i7 = index;
            that.list[a].children[secondNum].children[i7].badge = parseInt(that.leftNum.msg.oldcont);
          }
          if (element.powercode == '1c895257-a000-d008-b001-adb6df000006') {//工伤纠纷提醒
            let i8 = index;
            that.list[a].children[secondNum].children[i8].badge = parseInt(that.leftNum.msg.hurtcount);
          }
        });
      }
    },
    // qaq() {
    //   this.$store.commit("setShowNav", true);
    // },
    // 切换一级栏目
    cutStair(index,item) {
      let that = this
      // this.pathName = item.path
      // 点击到项目提醒时获取商务合同提醒数量
      if((item.powername == '客户')||(this.pathName.indexOf('projectList')>-1||this.pathName.indexOf('exportList')>-1||this.pathName.indexOf('contractReminder')>-1||this.pathName.indexOf('customerList')>-1||this.pathName.indexOf('customList')>-1||this.pathName.indexOf('cusExportList')>-1||this.pathName == '/')) {
        that.$store.commit("SET_Pronum");
      }
      this.$store.commit("setShowNav", true);
      if (that.show === false) {
        //小图标显示
        that.showOn = true;
      }
      item.checked = true;
      that.second = index;
      that.current = index;
      localStorage.setItem("defaultIndex", Number(index));
      // if(item.powername == '报表'){// 展开指定菜单
        // that.$refs.menuref.open('/basicReport');
      // }
      // 根据路由判断子级菜单选中
      this.activeMenu();
      that.list.forEach((item, index) => {
        if (index == that.current) {
          if (localStorage.needEdit == 'true') {
            that.$message.warning('请先修改初始密码！')
            return
          }
        } else {
          // if(that.activePath != that.defaultpath){//判断一级菜单选中状态，是否有选中其他页面
          //   item.checked = true;
          // }else{
            item.checked = false;
          // }
        }
      });
      // console.log('sss',this.activePath,that.defaultpath);
      this.setPathOn(item.powername);
    },
    // 根据树结构节点path从树结构数据中获取节点数据
    getTreeName(treeList,path){
      let _this = this
      for (let i = 0; i < treeList.length; i++) {
        let treeItem = treeList[i]
        if(treeItem.path == path){
          return {treeItem: treeItem, childindex: i}
        }else{
          if(treeItem.children && treeItem.children.length>0){
            let res = _this.getTreeName(treeItem.children,path)
            if(res){
              return {res: res, parentindex: i}
            }
          }
        }
      }
    },
    // 设置菜单选中状态
    setPathOn(powername) {
      if (powername == '通知') {
        this.$store.commit("getLeftNum");
      }else if(this.pathName.indexOf('T')>-1&&(powername != '通知')){
        this.$store.commit("getLeftNum");
      }else if(powername == undefined){
        this.$store.commit("getLeftNum");
      }
      // this.$store.dispatch("SetRouter", activeRouter)
      if (this.show === false) {
        //小图标显示
        this.showOn = false;
      }
      // this.list.forEach((item, index) => {
      //   item.meta.checked = false;
      //   if (item.children != undefined) {
      //     item.children.forEach((ite, ind) => {
      //       if (this.$route.path === ite.path) {
      //         // ite.meta.checked = true;
      //         // item.meta.checked = true;
      //         this.current = 0;
      //         // this.second = localStorage.getItem("defaultIndex")
      //         // localStorage.setItem("defaultIndex", Number(index));
      //       } else {
      //         ite.meta.checked = false;
      //       }
      //     })
      //   }
      // })
    },
    //判断是否为空
    isNull(o) {
      return (
        o === undefined ||
        o === "undefined" ||
        (o + "").indexOf("undefined") > -1 ||
        o === null ||
        o === "" ||
        o === "null" ||
        o === [] ||
        o === "NaN"
      );
    },
  }
}
</script>
<style scoped>
.icon-box {
  margin: 0 auto;
  text-align: center;
}
.nav-badge {
  position: relative;
}
.nav-badge .el-badge {
  position: absolute;
  transform: translateY(-40%);
  top: 0;
  right: -10px;
}
.navigation {
  background: #ffffff;
  width: 224px;
  position: relative;
  box-shadow: 3px 0 7px -7px #5e5e5e;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.navigation .stair {
  width: 60px;
  background: #353535;
  height: 100%;
  z-index: 2000;
}
.navigation .stair li {
  cursor: pointer;
  padding: 7px 0;
}
.navigation .stair li:hover,
.navigation .stair li.on {
  background: #000000;
}
.navigation .stair li:hover .icon-box span,
.navigation .stair li.on .icon-box span,
.navigation .stair li:hover .navigation-icon,
.navigation .stair li.on .navigation-icon {
  color: #19bd92;
}
.navigation .stair li .icon-box span {
  display: block;
  margin-top: 3px;
  color: rgba(255, 255, 255, 0.5);
}
.navigation .stair .navigation-icon {
  width: 15px;
  height: 15px;
  display: block;
  background-size: 100% auto;
  margin: 0 auto;
  color: #fdfdfd;
  font-size: 16px;
}
.navigation .stair li:hover .navigation-icon.el-icon-notebook-2,
.navigation .stair li:hover .navigation-icon.el-icon-document {
  color: #19bd92;
}
.navigation .stair li.on .navigation-icon.el-icon-notebook-2,
.navigation .stair li.on .navigation-icon.el-icon-document {
  color: #19bd92;
}
.navigation .stair .navigation-icon.navigation-icon-user {
  background-image: url("../assets/employee/images/navigation-user.png");
  width: 20px;
  height: 20px;
}
.navigation .stair li:hover .navigation-icon.navigation-icon-user,
.navigation .stair li.on .navigation-icon.navigation-icon-user {
  background-image: url("../assets/employee/images/navigation-user-on.png");
}
.navigation .stair .navigation-icon.navigation-icon-statistics {
  background-image: url("../assets/employee/images/navigation-statistics.png");
}
.navigation .stair li:hover .navigation-icon.navigation-icon-statistics,
.navigation .stair li.on .navigation-icon.navigation-icon-statistics {
  background-image: url("../assets/employee/images/navigation-statistics-on.png");
}
.navigation .stair .navigation-icon.navigation-icon-backlog {
  background-image: url("../assets/employee/images/navigation-backlog.png");
}
.navigation .stair li:hover .navigation-icon.navigation-icon-backlog,
.navigation .stair li.on .navigation-icon.navigation-icon-backlog {
  background-image: url("../assets/employee/images/navigation-backlog-on.png");
}
.navigation .stair .navigation-icon.navigation-icon-roster {
  background-image: url("../assets/employee/images/navigation-roster.png");
}
.navigation .stair li:hover .navigation-icon.navigation-icon-roster,
.navigation .stair li.on .navigation-icon.navigation-icon-roster {
  background-image: url("../assets/employee/images/navigation-roster-on.png");
}
.navigation .stair .navigation-icon.navigation-icon-oa {
  background-image: url("../assets/employee/images/navigation-oa.png");
}
.navigation .stair li:hover .navigation-icon.navigation-icon-oa,
.navigation .stair li.on .navigation-icon.navigation-icon-oa {
  background-image: url("../assets/employee/images/navigation-oa-on.png");
}

.navigation .stair .navigation-icon.navigation-icon-jurisdiction {
  background-image: url("../assets/employee/images/navigation-jurisdiction.png");
}
.navigation .stair li:hover .navigation-icon.navigation-icon-jurisdiction,
.navigation .stair li.on .navigation-icon.navigation-icon-jurisdiction {
  background-image: url("../assets/employee/images/navigation-jurisdiction-on.png");
}
.navigation .stair .navigation-icon.navigation-bank {
  background-image: url("../assets/employee/images/navigation-bank.png");
  width: 20px;
  height: 20px;
}
.navigation .stair li:hover .navigation-icon.navigation-bank,
.navigation .stair li.on .navigation-icon.navigation-bank {
  background-image: url("../assets/employee/images/navigation-bank-on.png");
}
.navigation .second {
  /* position:absolute;
  top: 0;
  left: 50px; */
  width: 160px;
  z-index: 1999;
  background: #ffffff;
  height: 100%;
  overflow-y: auto;
}
.navigation .second .title {
  margin-top: 20px;
  font-size: 16px;
  font-weight: bold;
  color: #353535;
  line-height: 22px;
  margin-bottom: 20px;
  padding-left: 10px;
}
.navigation .second li {
  position: relative;
  line-height: 45px;
  font-size: 14px;
  font-weight: 500;
  color: #353535;
  padding-left: 10px;
  cursor: pointer;
}
.navigation .second li.on {
  color: #19bd92;
  background: #ebfaf5;
  font-weight: bold;
  border-right: 4px solid #19bd92;
}
.navigation .second li:hover {
  background: #f3f3f3;
}
.confirm {
  background: #ebfaf5;
  border: 1px solid #19bd92;
  color: #19bd92;
}
.confirm:hover {
  background: #ebfaf5;
  border: 1px solid #19bd92;
  color: #19bd92;
}
.cancel {
  color: #76a196;
  border-radius: 2px;
  border: 1px solid #e1ebe7;
  background: #ffffff;
}
.cancel:hover {
  color: #76a196;
  border-radius: 2px;
  border: 1px solid #e1ebe7;
  background: #ffffff;
}
 /*滚动条样式*/
 .navigation .second::-webkit-scrollbar {
    width: 4px;
    /* display: none; */
  }

  .navigation .second::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }

  .navigation .second::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);

  }
</style>

<style>
.navigation .nest-menu .el-badge.mark {
  position: absolute;
  left: 15px;
  top: -12px;
}
.navigation .el-menu{
  border: none;
}
.navigation .el-menu--collapse{
  width: auto;
}
.navigation .el-submenu .el-menu-item{
  position: relative;
  height: 40px;
  min-width: auto;
  line-height: 40px;
  padding: 0 20px 0 25px!important;
}
.navigation .el-menu .el-submenu .el-submenu__title:hover,
.navigation .el-menu .el-menu-item.submenu-title-noDropdown:hover,
.navigation .el-menu .nest-menu .el-menu-item:hover{
  /* background-color: rgb(165, 164, 164,.8)!important; */
  background-color: rgb(166, 247, 220,.5)!important;
}
.navigation .el-submenu .el-submenu__title{
  background-color: #ebfaf5!important;
  color:rgb(87, 87, 87)!important;
}
.navigation .el-submenu.is-active .el-submenu__title{
  color:#000!important;
  font-weight: 550;
}
.navigation .el-menu .nest-menu .el-menu-item.is-active,
.navigation  .el-menu-item.submenu-title-noDropdown.is-active{
  color: #19bd92!important;
  font-weight: 600;
}
.navigation .el-menu-item.submenu-title-noDropdown{
  background-color: #ebfaf5!important;
  /* background-color: rgb(200, 200, 200,.8)!important; */
  color:rgb(87, 87, 87)!important;
}
.navigation .el-menu .nest-menu .el-menu-item{
  /* background-color: rgba(194, 193, 193)!important; */
  color:rgb(87, 87, 87)!important;
  /* background-color: #ebfaf5!important; */
  background-color: #fff!important;
  
}
.navigation .el-submenu .el-submenu__title i{
  color:#353535;
}
.navigation .el-submenu.is-active .el-submenu__title i{
  font-weight: bold;
}
.navigation .el-submenu__title,
.navigation .el-menu-item{
  height: 45px;
  line-height: 45px;
}
.navigation .el-scrollbar__bar{
  opacity: 0!important;
}
.stair .el-badge__content {
  padding: 0 5px;
  margin-left: -32px;
}
</style>